// frontend/src/ReleaseNotes/releaseNotesUiSpecs.ts
import type { IImpact, IModule, IReleaseType } from "@multiconsult-group/multiplacer-core";

export const RELEASE_MODULE_LABEL: Record<IModule, string> = {
  CEILING: "Himling",
  RFP: "RFP",
  EXPLORE: "Utforsk",
  ROOM_NUMBERING: "Romnummerering",
};

export const RELEASE_TYPE_LABEL: Record<IReleaseType, string> = {
  added: "Ny",
  changed: "Endret",
  fixed: "Fikset",
};

export const RELEASE_IMPACT_LABEL: Record<IImpact, string> = {
  low: "Lav",
  medium: "Middels",
  high: "Høy",
};

export type ISelectOption<T extends string> = { value: T; label: string };

export const RELEASE_MODULE_OPTIONS: ISelectOption<IModule>[] = [
  { value: "CEILING", label: RELEASE_MODULE_LABEL.CEILING },
  { value: "RFP", label: RELEASE_MODULE_LABEL.RFP },
  { value: "EXPLORE", label: RELEASE_MODULE_LABEL.EXPLORE },
  { value: "ROOM_NUMBERING", label: RELEASE_MODULE_LABEL.ROOM_NUMBERING },
];

export const RELEASE_TYPE_OPTIONS: ISelectOption<IReleaseType>[] = [
  { value: "added", label: RELEASE_TYPE_LABEL.added },
  { value: "changed", label: RELEASE_TYPE_LABEL.changed },
  { value: "fixed", label: RELEASE_TYPE_LABEL.fixed },
];

export const RELEASE_IMPACT_OPTIONS: ISelectOption<IImpact>[] = [
  { value: "low", label: RELEASE_IMPACT_LABEL.low },
  { value: "medium", label: RELEASE_IMPACT_LABEL.medium },
  { value: "high", label: RELEASE_IMPACT_LABEL.high },
];
